import { ILatestAction } from './ILatestAction.js'

/** This interface defines a bill object that is returned by the API. */
export interface IBill {
  congress: number
  latestAction: ILatestAction
  number: string
  originChamber: string
  originChamberCode: string
  title: string
  type: string
  updateDate: string
  updateDateIncludingText: string
  url: string
}
